import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../components/Layout";
import SafetyWarningDialog from "../components/SafetyWarningDialog";
import PostCard from "../components/PostCard";
import PostComposer from "../components/PostComposer";
import CauldronCoinBanner from "../components/CauldronCoinBanner";
import LockupNudge from "../components/LockupNudge";
import FeaturedPractitionersRail from "../components/FeaturedPractitionersRail";
import FeaturedNewPractitioners from "../components/FeaturedNewPractitioners";
import FrictionFixDialog from "../components/FrictionFixDialog";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Feed() {
  const { user, profile } = useAuth();
  const [posts, setPosts] = useState([]);
  const [params] = useSearchParams();
  const composerType = (params.get("composer") || "").toUpperCase();
  const wantsComposer = ["TEXT", "IMAGE", "VIDEO", "LINK", "LIVE"].includes(composerType);

  const load = async () => {
    const { data } = await api.get("/posts");
    setPosts(data);
  };
  useEffect(() => { load(); }, []);

  const rightRail = (
    <>
      <LockupNudge />
      <FeaturedPractitionersRail />
      <div className="parchment p-6">
        <div className="label-mystic mb-2">Sponsored</div>
        <div className="font-serif text-xl mb-2">Boost your shrine.</div>
        <p className="text-sm text-foreground/70 mb-3">Reach seekers across the Cauldron with paid ad campaigns.</p>
        <a href="/ads" className="text-secondary hover:text-secondary/80 text-sm uppercase tracking-wider" data-testid="rightrail-ads-link">Create campaign →</a>
      </div>
    </>
  );

  // Admins and active practitioners can post; clients always can.
  const canPractice = user && (user.role === "PROVIDER" || user.role === "ADMIN");
  const canPost = user && (!canPractice || profile?.subscriptionStatus === "active");

  return (
    <Layout rightRail={rightRail}>
      <SafetyWarningDialog trigger="feed" />
      <FrictionFixDialog />
      <div className="space-y-6">
        <CauldronCoinBanner />
        <FeaturedNewPractitioners days={7} limit={12} />
        {canPost && <PostComposer onPosted={(p) => setPosts([p, ...posts])} defaultType={wantsComposer ? composerType : "TEXT"} autoFocus={wantsComposer} />}
        {!canPost && canPractice && (
          <div className="parchment p-6 text-center">
            <p className="text-foreground/80">Activate your subscription to post on the feed.</p>
            <a href="/subscribe" className="inline-block mt-3 bg-primary text-primary-foreground px-6 py-2 rounded-sm uppercase tracking-wider text-xs" data-testid="feed-subscribe-cta">Subscribe</a>
          </div>
        )}
        <div className="space-y-6" data-testid="feed-list">
          {posts.map((p) => (
            <PostCard
              key={p.id}
              post={p}
              onUpdate={(np) => setPosts(posts.map(x => x.id === np.id ? np : x))}
              onRemove={(pid) => setPosts((arr) => arr.filter((x) => x.id !== pid))}
            />
          ))}
          {posts.length === 0 && <div className="parchment p-12 text-center text-foreground/60 font-serif text-2xl">The cauldron is still. Be the first to speak.</div>}
        </div>
      </div>
    </Layout>
  );
}
